export interface ChartRenderMetric {
    id: string;
    label: string;
    latestMs: number;
    averageMs: number;
    budgetMs: number;
    withinBudget: boolean;
    updatedAt: number;
}

class ChartRenderTelemetryStore {
    private readonly metrics = new Map<string, ChartRenderMetric>();

    report(metric: ChartRenderMetric): void {
        this.metrics.set(metric.id, metric);
    }

    snapshot(): {
        count: number;
        overBudget: number;
        averageLatestMs: number;
        updatedAt: number | null;
        items: ChartRenderMetric[];
    } {
        const items = Array.from(this.metrics.values()).sort((a, b) => b.updatedAt - a.updatedAt);
        const count = items.length;
        const overBudget = items.filter(item => !item.withinBudget).length;
        const averageLatestMs = count
            ? items.reduce((sum, item) => sum + item.latestMs, 0) / count
            : 0;
        const updatedAt = count ? items[0].updatedAt : null;

        return { count, overBudget, averageLatestMs, updatedAt, items };
    }
}

const store = new ChartRenderTelemetryStore();

export function reportChartRenderMetric(input: {
    id: string;
    label: string;
    latestMs: number;
    averageMs: number;
    budgetMs: number;
    withinBudget: boolean;
}): void {
    store.report({
        ...input,
        updatedAt: Date.now(),
    });
}

export function getChartRenderTelemetrySnapshot(): {
    count: number;
    overBudget: number;
    averageLatestMs: number;
    updatedAt: number | null;
    items: ChartRenderMetric[];
} {
    return store.snapshot();
}
